import { Button, Row, Col, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

function LandingPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();
  const { Title } = Typography;
  const companies = useSelector((state) => state.lookup.companyNames);
  const [showFirst, setShowFirst] = useState(true);
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const userName = localStorage.getItem("userName");
  const selectedlanguage = localStorage.getItem("selectedlanguage");
  const speed = 50;

  const typeWriter = (text, setText, callback) => {
    let index = 0;
    let result = "";

    const interval = setInterval(() => {
      result += text.charAt(index); // use local string
      setText(result); // set final string state
      index++;

      if (index === text.length) {
        clearInterval(interval);
        if (callback) callback();
      }
    }, speed);
  };

  useEffect(() => {
    const fullText1 = intl.formatMessage(
      { id: "Landing.WelcomeUser" },
      { userName }
    );
    const fullText2 = intl.formatMessage({ id: "Landing.ProceedChoice" });
    setText1("");
    setText2("");
    setShowFirst(true);
    typeWriter(fullText1, setText1, () => {
      setTimeout(() => {
        setShowFirst(false);
        setText2("&nbsp;"); // Clear before second typing starts
        typeWriter(fullText2, setText2);
      }, 1000);
    });
  }, [selectedlanguage, userName]);

  const handleOnClick = (companyId) => {
    localStorage.setItem("CompanyId", companyId);
    navigate(`/${companyId}/dashboard`);
    navigate(`/${companyId}/dashboard`);
  };

  return (
    <div
      className="oxyy-login-register"
      style={{
        textAlign: "center",
        background: "#fff",
      }}
    >
      <Row gutter={[16, 16]} justify="center">
        <Col xs={24} sm={12} md={24} lg={16}>
          <Title
            level={2}
            className="text-13"
            style={{
              fontWeight: 300,
              marginBottom: "40px",
              marginTop: "110px",
            }}
          >
            {showFirst ? text1 : text2}
          </Title>

          <Row gutter={[24, 32]} justify="center" className="company-list">
            {companies?.map((company) => (
              <Col key={company.id} xs={24} sm={12} md={8} lg={8}>
                <a onClick={() => handleOnClick(company.id)}>
                  <div className="bg-white">{company.companyName}</div>
                </a>
              </Col>
            ))}
            <Col xs={24} sm={12} md={8} lg={8}>
              <a>
                <div className="bg-white">
                  <FormattedMessage id="Landing.CorporateNews" />
                </div>
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default LandingPage;
